import { useDashboardCustomerMembershipState } from '../../dahsboardCustomerMembershipState';
import { DiscountModal } from './DiscountModal';

interface DiscountProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
}
export const Discount = ({ isModalOpen, setIsModalOpen }: DiscountProps) => {
  const { dashboardCustomerMembershipState } =
    useDashboardCustomerMembershipState();

  const value = dashboardCustomerMembershipState.discount
    ? dashboardCustomerMembershipState.discount.value
    : '없음';

  const unit = dashboardCustomerMembershipState.discount
    ? dashboardCustomerMembershipState.discount.unit === 'percent'
      ? '%'
      : '원'
    : '';

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className="h-[37px] px-16 py-8 bg-[#2e2a3a] rounded-lg justify-center items-center gap-1 inline-flex"
      >
        <div className="text-[#d7d2de] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
          {value} {unit}
        </div>
      </div>
      {isModalOpen && <DiscountModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};
